<template>
  <div class="notice">
    <div class="rowheader">
      <div class="headertext">
        <span>盈浦街道</span>
        <span>{{ ggmc }}</span>
      </div>
      <div class="rowdetailbtn" @click="$router.push('/noticedetail')">
        <span>更多</span>
        <div class="rounda">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="rowcontainer">
      <!-- <div class="showimg">
        <el-image :src="datalist[0].img_url" class="imga">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>-->
      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span>卡片名称</span>
          </div>
        </template>
        <div>
          <!-- 选项部分 -->
          <el-select v-model="selected" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-card>
      <el-card class="showitem" v-for="(item, i) in datalist" :key="i">
        <div class="itemcon" @click="todetail(item)">
          <div class="itemimg">
            <div>
              <span>{{ item.update_time.split(" ")[0].split("-")[2] }}</span>
            </div>
            <div>
              <span>{{ item.update_time.split(" ")[0].split("-")[0] }}</span>-
              <span>{{ item.update_time.split(" ")[0].split("-")[1] }}</span>
            </div>
          </div>
          <div class="txtcon">
            <div>{{ item.title }}</div>
            <div class="txtsmall">
              <div :title="item.describe">
                <span>
                  <i class="el-icon-paperclip"></i> 描述:
                </span>
                <span>{{ item.describe }}</span>
              </div>
              <div :title="item.author">
                <span>
                  <i class="el-icon-user"></i> 作者:
                </span>
                <span>{{ item.author }}</span>
              </div>
              <div :title="item.label">
                <span>
                  <i class="el-icon-collection-tag"></i> 标签:
                </span>
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  data() {
    return {
      datalist: [
        // {
        //   name: "11111111",
        //   img: require("@/assets/images/beijing.png"),
        // },
        // {
        //   name: "11111111",
        //   img: require("@/assets/images/beijing.png"),
        // },
        // {
        //   name: "11111111",
        //   img: require("@/assets/images/beijing.png"),
        // },
        // {
        //   name: "11111111",
        //   img: require("@/assets/images/beijing.png"),
        // },
        // {
        //   name: "11111111",
        //   img: require("@/assets/images/beijing.png"),
        // },
      ],
      ggmc: '',
      selected: '',
      options: [
        {value:'选项1',label:'3131'},
        {value:'选项2',label:'收到'},
        {value:'选项3',label:'放到'},
        {value:'选项4',label:'股份'},
        {value:'选项5',label:'测试'},
      ]
    };
  },
  created() { },
  computed: {},
  mounted() {
    this.getdata();
    // this.getdhmc();
  },
  methods: {
    getdata() {
      // let data = this.$qs.stringify({

      // });
      // console.log(data)
      this.$axios({
        method: "post",
        url: "/admin/kjhqt/notice_list_zs_sy",
        // data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res)
            this.datalist = res.data.data;
          }
        })
        .catch(err => {
          //this.$message.error(err);
        });
    },
    todetail(i) {
      this.$router.push({
        name: "noticedetail",
        params: {
          item: i
        }
      });
    },
    getdhmc() {
      // let data = this.$qs.stringify({
      // });
      this.$axios({
        method: "post",
        url: "/admin/kjhqt/dh_module_list",
        // data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res)
            this.list = res.data.data;
            this.ggmc = res.data.data[0]['module_name'];
            // this.ztmc = res.data.data[1]['module_name'];
            // this.spzbmc = res.data.data[2]['module_name'];
            // this.wzmc = res.data.data[3]['module_name'];
            // this.zlmc = res.data.data[4]['module_name'];
          }
        })
        .catch(err => {
           //this.$message.error(err);
        });
    }
  },
};
</script>
<style lang="less" scoped>
.notice {
  width: 100%;
  height: 100%;
  .rowheader {
    width: 100%;
    height: 120px;
    position: relative;
    .headertext {
      width: 50%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 600;
      font-size: 3.6vh;
      letter-spacing: 0.08em;
      color: #00041a;
    }
    .rowdetailbtn {
      position: absolute;
      right: 0;
      bottom: 10px;
      font-weight: 500;
      font-size: 1.8vh;
      color: #3353ff;
      line-height: 15px;
      cursor: pointer;
      .rounda {
        display: inline-block;
        margin-left: 5px;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: #3353ff;
        color: white;
        font-size: 10px;
        line-height: 15px;
        text-align: center;
      }
    }
  }
  .rowcontainer {
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    flex-direction: row;
    .showimg {
      height: 335px;
      > .imga {
        width: 85%;
        // height: 335px;
        aspect-ratio: 16/9;
      }
    }
    .showitem {
      height: 105px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: 45%;
      margin-top: 10px;
      .itemcon {
        width: 90%;
        height: 90%;
        margin-left: 20px;
        display: flex;
        justify-content: left;
        // border-bottom: 1px solid grey;
        .itemimg {
          width: 74px;
          height: 74px;
          border: 1.45946px solid #9d9d9d;
          // margin-top: 46px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          > div {
            text-align: center;
          }
          > div:nth-of-type(1) {
            font-weight: 700;
            font-size: 3.8vh;

            color: #000000;
          }
          > div:nth-of-type(2) {
            margin-top: 10px;
            font-weight: 400;
            font-size: 1.5vh;

            color: #555555;
          }
        }
        .txtcon {
          width: calc(100% - 100px);
          height: 74px;
          margin-left: 20px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          > div:nth-of-type(1) {
            font-weight: 500;
            line-height: 2.7vh;
            font-size: 2vh;
            color: #000000;
            word-break: break-all;
            text-overflow: -o-ellipsis-lastline;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-clamp: 2;
          }
          .txtsmall {
            display: flex;
            justify-content: space-between;
            > div {
              width: 20%;
              height: 100%;
              text-align: left;
              font-size: 0.8vh;
              color: grey;
              word-break: break-all;
              text-overflow: -o-ellipsis-lastline;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              line-clamp: 1;
            }
            > div:nth-of-type(1) {
              width: 35%;
            }
            > div:nth-of-type(2) {
              width: 25%;
            }
          }
        }
      }
    }

    .showitem:hover {
      // border: 1px solid #4260ff;
      // border-radius: 6px;
      // // margin-top: 13px;
      // .itemcon {
      //   border: none;
      // }
      transform: scale(1.02);
    }
    .box-card {
      width: 300px;
    }
    .card-header {
       display: flex;
       justify-content: space-between;
       align-items: center;
    }
  }
}
</style>


